module.exports = __webpack_public_path__ + "static/16-b0d8eaa4cba9367d9b6d7f84aa18d7ed.jpg";